import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from "@angular/router";

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class FooterComponent {
    constructor (private router: Router) {}

    navigateToHomePage () {
        this.router.navigateByUrl('/');
        window.scrollTo(0,0);
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/moddules/footer/footer.component.ts